import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useClipPathId } from "../hooks/use-clip-path-id";

export function AskFilled(props) {
  const clipPathId = useClipPathId("ask-filled");
  return (
    <SvgIcon {...props}>
      <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M12 2C6.52632 2 2 6.52632 2 12C2 17.4737 6.52632 22 12 22C17.5789 22 22 17.4737 22 12C22 6.52632 17.5789 2 12 2ZM12 17.0526C11.3684 17.0526 10.8421 16.5263 10.8421 15.8947C10.8421 15.2632 11.3684 14.7368 12 14.7368C12.6316 14.7368 13.1579 15.2632 13.1579 15.8947C13.1579 16.5263 12.6316 17.0526 12 17.0526ZM13.2632 11.5789C12.6316 12 12.6316 12.3158 12.6316 12.6316C12.6316 13.0526 12.3158 13.4737 11.7895 13.4737C11.2632 13.4737 10.9474 13.1579 10.9474 12.6316C10.9474 11.6842 11.3684 10.9474 12.3158 10.3158C13.1579 9.78947 13.3684 9.47368 13.3684 8.94737C13.3684 8.73684 13.2632 8.31579 12.6316 8C12.5263 8 12.3158 7.89474 11.8947 7.89474C11.4737 7.89474 11.1579 8 10.9474 8.21053C10.6316 8.42105 10.6316 8.84211 10.6316 8.84211C10.6316 9.26316 10.2105 9.57895 9.78947 9.57895C9.36842 9.57895 8.94737 9.1579 9.05263 8.73684C9.05263 8.63158 9.1579 7.68421 10.1053 6.84211C10.6316 6.42105 11.2632 6.21053 12 6.21053C12.5263 6.21053 13.0526 6.31579 13.3684 6.42105C14.4211 6.94737 14.9474 7.78947 14.9474 8.73684C15.0526 10.3158 14 11.0526 13.2632 11.5789Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect fill="white" height="24" width="24" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
